import { render } from "./detail.vue?vue&type=template&id=32fb429b&scoped=true"
import script from "./detail.vue?vue&type=script&lang=js"
export * from "./detail.vue?vue&type=script&lang=js"

import "./detail.vue?vue&type=style&index=0&id=32fb429b&scoped=true&lang=css"

import exportComponent from "D:\\GitLocal\\mvs-sys\\mvsui-user\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-32fb429b"]])

export default __exports__